import { useEffect, useState } from "react";
import ImageSlider, { Slide } from "react-auto-image-slider";
import { Col, Container, Image, Row, Table } from "react-bootstrap";
import SwiperCore from "swiper";
import "swiper/css";
import { Mousewheel } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import logo from "./assets/images/black_logo.mp4";
import dentalMaxImage from "./assets/images/dentalmax.png";
import hsImage from "./assets/images/hs.png";
import iactImage from "./assets/images/iact.png";
import img1 from "./assets/images/img1.png";
import img2 from "./assets/images/img2.png";
import img3 from "./assets/images/img3.png";
import img4 from "./assets/images/img4.png";
import mdxImage from "./assets/images/mdx.png";
import newsysImage from "./assets/images/newsys.jpg";
import patternnImage from "./assets/images/patternn.png";
import sungwooImage from "./assets/images/sungwoo.png";
import { Map, MapMarker } from "react-kakao-maps-sdk";

function MobileView() {
    const [swiper, setSwiper] = useState<SwiperCore>();

    useEffect(() => {
        window.TypeHangul.type("#vision", {
            intervalType: 50,
            humanize: 0.5
        });
    }, []);

    return (
        <>
            <Container className="fixed-top top-navbar pt-4">
                <Row className="align-items-center">
                    <Col xs={3}>
                        <video className="mobile-video" muted autoPlay loop preload="auto" playsInline>
                            <source src={logo} type="video/mp4" />
                        </video>
                    </Col>
                    <Col xs={3} className="menu-bar" style={{ cursor: "pointer" }} onClick={() => swiper?.slideTo(1)}>
                        About Us
                    </Col>
                    <Col xs={3} className="menu-bar" style={{ cursor: "pointer" }} onClick={() => swiper?.slideTo(3)}>
                        Solutions
                    </Col>
                    <Col xs={3} className="menu-bar" style={{ cursor: "pointer" }} onClick={() => swiper?.slideTo(4)}>
                        Location
                    </Col>
                </Row>
            </Container>
            <Swiper
                onSwiper={setSwiper}
                className="h-100"
                spaceBetween={0}
                slidesPerView={1}
                direction={"vertical"}
                mousewheel={true}
                modules={[Mousewheel]}
            >
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-start justify-content-center text-center mobile-backgroundImage">
                            <Col id="vision" className="mobile-vision">
                                세상의 가치와 사람, 정보기술을 연결하는 매듭
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center text-center mb-5">
                            <Col xs={12}>
                                <Row className="mb-2">
                                    <Col xs={4} className="subtitle">
                                        Office
                                    </Col>
                                    <Col xs={8}></Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <ImageSlider effectDelay={1000} autoPlayDelay={4000}>
                                            <Slide>
                                                <Image src={img1} height={300} />
                                            </Slide>
                                            <Slide>
                                                <Image src={img2} height={300} />
                                            </Slide>
                                            <Slide>
                                                <Image src={img3} height={300} />
                                            </Slide>
                                            <Slide>
                                                <Image src={img4} height={300} />
                                            </Slide>
                                        </ImageSlider>
                                    </Col>
                                </Row>
                                <Row className="mt-3 mb-2">
                                    <Col xs={4} className="subtitle">
                                        History
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2025.08. 익명 기반 개인키 복원 기술 특허 등록
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2025.04. 혁신성장유형 벤처기업인증
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2024.12. (주)성우 압력측정기 관리프로그램 개발
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2024.07. 희성산업 로봇 용접 생산·관리시스템 개발
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2024.05. (주)엠디엑스 무인카페 키오스크 프로그램 개발
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2024.03. 연구전담부서 설립인가
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2024.02. 대구여성인력개발센터 업무협약 체결
                                    </Col>
                                </Row>
                                <Row className="ps-2">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2024.01. (주)엠디엑스 업무제휴 협약 체결
                                    </Col>
                                </Row>
                                <Row className="ps-2 mb-5">
                                    <Col xs={12} className="text-start mobile-content-text">
                                        2023.11. 주식회사 노트랩 법인 설립
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center text-center ps-3 pe-3 pb-5">
                            <Col>
                                <Row className="text-start mb-3">
                                    <Col className="subtitle">
                                        Partner Company
                                    </Col>
                                </Row>
                                <Row className="mb-5 pb-4">
                                    <Col className="pt-4 pb-4 all-border">
                                        <Row>
                                            <Col>
                                                <Image src={mdxImage} height={40} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col>
                                                <Image src={sungwooImage} height={40} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col>
                                                <Image src={newsysImage} height={40} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col>
                                                <Image src={iactImage} width={200} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col>
                                                <Image src={dentalMaxImage} height={40} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col>
                                                <Image src={hsImage} height={40} />
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col>
                                                <Image src={patternnImage} height={40} />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center text-center ps-3 pe-3">
                            <Col>
                                <Row className="text-start mb-3">
                                    <Col className="subtitle">
                                        Solutions
                                    </Col>
                                </Row>
                                <Row className="mb-5 pb-4">
                                    <Col className="pt-4 pb-2 all-border">
                                        <Row>
                                            <Col>
                                                <Table className="mobile-table">
                                                    <tbody>
                                                        <tr>
                                                            <td className="vertical-header">제품</td>
                                                            <td>KD-MMS</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">기능</td>
                                                            <td>가공 공정 모니터링 시스템</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">월 단가(원)</td>
                                                            <td>₩1,440,000</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Table className="mobile-table">
                                                    <tbody>
                                                        <tr>
                                                            <td className="vertical-header">제품</td>
                                                            <td>KD-OMS</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">기능</td>
                                                            <td>조립 공정 관리 시스템</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">월 단가(원)</td>
                                                            <td>₩1,440,000</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Table className="mobile-table">
                                                    <tbody>
                                                        <tr>
                                                            <td className="vertical-header">제품</td>
                                                            <td>KD-MES</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">기능</td>
                                                            <td>공정 관리 시스템</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">월 단가(원)</td>
                                                            <td>₩1,440,000</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Table className="mobile-table">
                                                    <tbody>
                                                        <tr>
                                                            <td className="vertical-header">제품</td>
                                                            <td>KD-WMS</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">기능</td>
                                                            <td>배선 공정 관리 시스템</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="vertical-header">월 단가(원)</td>
                                                            <td>₩1,440,000</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
                <SwiperSlide>
                    <Container className="d-flex flex-column pt-5 h-100">
                        <Row className="flex-grow-1 d-flex align-items-center justify-content-center ps-3 pe-3 pb-5 mb-5">
                            <Col>
                                <Row className="text-start mb-3">
                                    <Col className="subtitle">
                                        Location
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className="pt-2 pb-2 all-border map-wrapper">
                                        <Map
                                            center={{ lat: 35.83527, lng: 128.68236 }}
                                            style={{ width: "100%", height: "100%" }}
                                            level={3}
                                        >
                                            <MapMarker
                                                position={{ lat: 35.83527, lng: 128.68236 }}
                                            />
                                        </Map>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col xs={12} className="pt-4 pb-4 ps-4 all-border">
                                        <Row>
                                            <Col className="paragraph-title">
                                                HeadQuater
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="mobile-content-text">
                                                대구광역시 수성구 알파시티1로 160, DNEX 602호
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col className="paragraph-title">
                                                Contact Us
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="mobile-content-text">
                                                Tel: 053-710-4800
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="mobile-content-text">
                                                Mail: knot@knotlab.kr
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row className="top-border pt-3 mt-5 mb-3">
                                    <Col>
                                        © 2025. Knotlab Inc. All rights reserved.
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </SwiperSlide>
            </Swiper>
        </>
    );
}

export default MobileView;